import * as http from "../../index";
import Configuration from "../../../config/index";
export const requestNewCase = (inquery) => {
    const host = Configuration.current().getApiAddress();
    const url = `${host}/credit-assessment/v2`;
    const forgeryToken = http.context().requestForgeryToken;
    const request = http
        .builder()
        .method("post")
        .accept("application/json")
        .requestForgeryToken(forgeryToken)
        .content(inquery)
        .build();
    return http.captureStateContext(http.json(url, request));
};
